import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics';
import ErrorPage from './view';

const ErrorPageWithAnalytics = AnalyticsData({
	attributes: {
		context: ANALYTIC_CONTEXTS.KNOWLEDGE,
	},
})(ErrorPage);

export default ErrorPageWithAnalytics;
